import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "@/components/ui/accordion";
import { Scale, Building2, ExternalLink, Phone, Info } from "lucide-react";

export default function Rights() {
  const [rights, setRights] = useState(null);
  const [orgs, setOrgs] = useState([]);

  useEffect(() => {
    api.get("/legal/rights").then((r) => setRights(r.data)).catch(() => {});
    api.get("/legal/service-public").then((r) => setOrgs(r.data.items)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6 adminia-fade-in">
      <div>
        <h1 className="font-heading font-bold text-2xl sm:text-3xl">Vos droits & démarches</h1>
        <p className="text-muted-foreground mt-1">Des repères fiables, toujours reliés à une source officielle.</p>
      </div>

      <div className="flex items-start gap-2 rounded-xl bg-brand/5 border border-brand/20 p-4 text-sm">
        <Info className="h-5 w-5 text-brand shrink-0 mt-0.5" />
        <p>{rights?.disclaimer || "Information à titre indicatif — à vérifier sur le site officiel."}</p>
      </div>

      {/* Vos droits */}
      <div>
        <h2 className="font-heading font-semibold text-lg mb-3 flex items-center gap-2">
          <Scale className="h-5 w-5 text-brand" /> Vos droits
        </h2>
        <Card className="p-2 sm:p-4">
          <Accordion type="single" collapsible>
            {rights?.items.map((r) => (
              <AccordionItem key={r.id} value={r.id} data-testid={`right-${r.id}`}>
                <AccordionTrigger className="text-left font-medium">{r.titre}</AccordionTrigger>
                <AccordionContent className="space-y-2">
                  <p className="font-medium text-foreground">{r.resume}</p>
                  <p className="text-muted-foreground leading-relaxed">{r.details}</p>
                  <a href={r.source_url} target="_blank" rel="noreferrer"
                    className="inline-flex items-center gap-1 text-xs text-brand font-medium">
                    {r.source} <ExternalLink className="h-3 w-3" />
                  </a>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Card>
      </div>

      {/* Annuaire */}
      <div>
        <h2 className="font-heading font-semibold text-lg mb-3 flex items-center gap-2">
          <Building2 className="h-5 w-5 text-brand" /> Mes démarches — annuaire officiel
        </h2>
        <div className="grid sm:grid-cols-2 gap-4">
          {orgs.map((o) => (
            <Card key={o.id} className="p-5 hover:shadow-md transition-shadow" data-testid={`org-${o.id}`}>
              <p className="font-heading font-semibold">{o.nom}</p>
              <p className="text-sm text-muted-foreground mt-1">{o.domaine}</p>
              <div className="flex flex-wrap items-center gap-4 mt-3">
                <a href={o.url} target="_blank" rel="noreferrer"
                  className="inline-flex items-center gap-1 text-sm text-brand font-medium">
                  Site officiel <ExternalLink className="h-3.5 w-3.5" />
                </a>
                {o.tel && (
                  <span className="inline-flex items-center gap-1 text-sm text-muted-foreground">
                    <Phone className="h-3.5 w-3.5" /> {o.tel}
                  </span>
                )}
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
